// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import 'normalize.css/normalize.css';
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import { getDomain } from 'sky-domain';
import VueDragResize from 'vue-drag-resize';
import sso from 'sso';
import skyRequest from 'skytech-request';
import App from './App';
import router from './router/index';
import igIcon from '@/components/iglobalwin/ig-icon/index';
import dataList from '@/components/iglobalwin/dataList/index';
import store from './store/index';
import '@/backend/styles/index.scss';
import '@/backend/styles/app.scss';
import '@/backend/styles/base.scss';
import '@/backend/permission';
import filters from '@/mixins/filters';
import skyEx from '@/common/sky-extends.js';
import commonFn from '@/common/commonFn';
import vCharts from 'v-charts';
import skyCharts from 'sky-charts';
import VueClipboard from 'vue-clipboard2';
import systemSwitch from 'system-switch';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import skyUpload from 'sky-upload';
import OSS from 'ali-oss';
// import hostConfig from '@/common/hostConfig.js';
import VInfiniteScroll from 'v-infinite-scroll';
import permissionData from '@/common/menuDict.js';
import 'lib-flexible/flexible';
import h5router from '@/utils/h5router.js';
import confirm from '@/utils/messageBox.js';
import requeryUrl from '@/common/requeryUrl.js';
import SkytechForm from 'skytech-vue2-form/dist/all.umd.min.js';
import 'skytech-vue2-form/dist/all.css';
Vue.prototype.$confirmShow = confirm;
window.ElementUI = ElementUI;
require('promise.prototype.finally').shim(); // promise.prototype.finally兼容性处理

Vue.use(ElementUI);
Vue.use(igIcon);
Vue.use(dataList);
Vue.use(vCharts);
Vue.use(skyCharts, {
	request: skyRequest,
});
Vue.use(VueClipboard);
Vue.use(VueQuillEditor);
Vue.use(VInfiniteScroll);
Vue.use(skyUpload, {
	request: skyRequest,
	getHost: getDomain,
	OSS,
});
Vue.use(SkytechForm);
Vue.component('vue-drag-resize', VueDragResize);
Vue.config.productionTip = false;
Object.keys(filters.filters).forEach(key => {
	Vue.filter(key, filters.filters[key]);
});

// v-chats报错解决
Vue._watchers = Vue.prototype._watchers = [];

async function _init() {
	// 创建一个URL对象
	const url = new URL(window.location.href);

	// 使用URLSearchParams对象来解析查询字符串
	const params = new URLSearchParams(url.search);

	// 获取单个参数值
	const state = params.get('state'); // "John"

	let res = await sso({
		request: skyRequest,
		currentSys: window,
		mode: process.env.NODE_ENV, //process.env.VUE_APP_SSO_ENV,
		code: 'iglobalwin',
		getHost: getDomain,
	});

	// H5路由判断
	let judgeVal = h5router();

	let system = systemSwitch.install(res);

	if (state) {
		window.open('', '_self');
		window.close();
	}

	if (judgeVal) {
		let permission = await res.checkPermissionInit.getPeoPermission();
		Vue.prototype.getPermission = name => {
			return permission.some(item => item.englishName === name);
		};
		await store.dispatch('GenerateRouters', permission);
	}

	Vue.use(system);
	skyRequest.install(function (status, message) {
		if (status == 412) {
			let data = commonFn.checkAll(message);
			store.commit('SET_WORDDIALOG', true);
			store.commit('SET_WORDDATA', data);
		} else {
			commonFn.tipPop.error(status, message);
		}
	});
	skyEx.add('sso', res);
	Vue.use(skyEx);

	Vue.prototype.$permissionData = permissionData;
	new Vue({
		router,
		store,
		render: h => h(App),
	}).$mount('#app');
}

_init();

skyRequest.RequestUse(
	config => {
		let id = sessionStorage.getItem('activeWebsiteId');
		// for (let key in apiConfig.liveChat) {
		if (config.url.includes('messenger/chat')) {
			config.url = requeryUrl(config.url, {
				serviceSiteId: id,
			});
			// }
		}
		let serviceSiteId = sessionStorage.getItem('serviceSiteId');
		if (config.url.includes('iglobalwin-ads-api')) {
			// 兼容全球赢ads账户管理接口
			config.url = requeryUrl(config.url, {
				serviceSiteId: serviceSiteId,
			});
		}
		return config;
	},
	() => {
		return Promise.reject();
	}
);
// Load the JavaScript SDK asynchronously
(function (d, s, id) {
	var js,
		fjs = d.getElementsByTagName(s)[0];
	if (d.getElementById(id)) return;
	js = d.createElement(s);
	js.id = id;
	js.src = 'https://connect.facebook.net/en_US/sdk.js';
	fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');
window.devUrl = `http://localhost:8080/?token=${window.localStorage.getItem('Authorization')}`;
